<div class="mt-5">
<article class="card">
    <div class="card-body">
        <div class="track" style="justify-content: space-between;">
        <!-- <div *ngFor="let step of steps; let i = index" class="step" [ngClass]="{'active': isStepActive(i)}"> -->
        <div *ngFor="let step of steps; let i = index" class="step" style="width: auto; flex-grow: 0; position: relative;" [ngClass]="{'active': isStepActive(i)}">
            <span class="icon">
                <i class="{{step.icon}}"></i>
            </span>
            <span class="text ord-desc" style="text-align: center;">{{ orderDataDetials[i]?.orderType || step.orderType }}</span>
            <!-- <span class="text description" *ngIf="i === 0">
                The order #{{orderDataDetials[0]?.orderId}} was placed on {{orderDataDetials[0]?.createdAt | date:'yyyy-MM-dd'}}.
            </span>
            <span class="text description" *ngIf="i === 1">
                The order still needs to be processed by our store before sending it to you.
            </span>
            <span class="text description" *ngIf="i === 2">
                The order has been picked up from courier and its on your way.
            </span>
            <span class="text description" *ngIf="i === 3">
                The package is on the way to deliver.
            </span>
            <span class="text description" *ngIf="i === 4">
                It seems like the package has delivered to customer Hope you are happy with it!
            </span> -->
        </div>
    </div>
    </div>
    </article>
</div>